/** The provider the AI calls every custom tool under, as `custom:<slug>`. */
export const CUSTOM_PROVIDER = 'custom';

export const CUSTOM_TOOLS_PATH = '/settings/integrations/custom-tools';

export const NEW_CUSTOM_TOOL_PATH = `${CUSTOM_TOOLS_PATH}/new`;

export const customToolPath = (id: string): string => `${CUSTOM_TOOLS_PATH}/${id}`;

/** The action page every tool has, where a custom tool's events and preconditions live. */
export const customToolActionPath = (slug: string): string => `/settings/integrations/${CUSTOM_PROVIDER}/actions/${slug}`;
